export default {
      id: "block_skylands-usage",
      viewBox: "0 0 232.45 263.09",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#block_skylands",
      toString: function () {
        return this.url;
      }
    }